import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicCartRecursiveResponse {
  @jsonMember(Date)
  public readonly firstRenewalDate!: Date;

  @jsonMember(Number)
  public readonly price!: number;
}
